import { render } from "./AppWidgetLatestVideo.html?vue&type=template&id=f24ce916"
import script from "./AppWidgetLatestVideo.js?vue&type=script&lang=js"
export * from "./AppWidgetLatestVideo.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__